import { NavigateFunction } from 'react-router';
import { ErrorCodes, ErrorCode, ErrorWithCodeResponse } from './exception-error-codes';
import { ROUTE_PATHS } from '../Routes';

type ExceptionReturn = {
	code: ErrorCode;
	message: string;
};

function handleErrorCodeExceptions(
	error: ErrorWithCodeResponse,
	navigate?: NavigateFunction,
): ExceptionReturn | undefined {
	switch (error.errorCode) {
		case ErrorCodes.QUOTE_REFERRED:
		case ErrorCodes.QUOTE_DECLINED:
			if (navigate) {
				navigate(ROUTE_PATHS.decline);
			} else {
				window.location.href = ROUTE_PATHS.decline;
			}
			return undefined;
		case ErrorCodes.PAYMENT_FAILED:
			return {
				code: error.errorCode,
				message: 'We were unable to process your payment. Please try again or use a different payment method.',
			};
		case ErrorCodes.PAYMENT_DECLINED:
			return {
				code: error.errorCode,
				message: 'Your payment was declined. Please verify your payment details or contact your card issuer.',
			};
		case ErrorCodes.PAYMENT_3DS_NOT_SUPPORTED_FOR_PROVIDER:
			return {
				code: error.errorCode,
				message: 'Your payment provider does not support 3D Secure. Please choose a different payment method.',
			};
		case ErrorCodes.PAYMENT_TOKEN_ALREADY_USED:
			return {
				code: error.errorCode,
				message: 'Something went wrong with the payment. Please try again.',
			};
		case ErrorCodes.QUOTE_MISMATCH:
			return {
				code: error.errorCode,
				message: 'There was a problem with your quote. Please try again.',
			};
		case ErrorCodes.PAYMENT_INSUFFICIENT_FUNDS:
			return {
				code: error.errorCode,
				message:
					'Unfortunately your payment was unsuccessful. Please try another payment method, or contact your bank or card provider.',
			};
		default:
			if (navigate) {
				navigate(ROUTE_PATHS.error);
			} else {
				window.location.href = ROUTE_PATHS.error;
			}
			return undefined;
	}
}

export default handleErrorCodeExceptions;
